import React from 'react';
import {
  footerHeadTop,
  footerHeadBottom,
  vertCenter
} from '../../partnerStyles';
import { Component } from 'react';
import PropTypes from 'prop-types';
import * as IMAGES from '../../Images';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { S3HOST } from '../../ApiConstants';
import view from '../../Enums';
import Fade from 'react-reveal/Fade';
import { Event } from '../../Modules/LandingPageNew/Tracking/Track';
import { hmsSelfOnboardingEnabled } from '../../config/countryConfig';
import OYO360Logo2 from '../../resources/vectors/OYO360Logo2';

let bottomDivWidth = '110px';

const FooterHead = props => {
  let gc = props.getContent;
  let guc = props.getUniversalContent;
  let gs = props.getStyle;
  let gi = props.getImage;
  return (
    <React.Fragment>
      <div style={{ ...footerHeadTop }}>
          { hmsSelfOnboardingEnabled() ? <div
              style={{ width: '10vw'}}>
              <OYO360Logo2/>
          </div> :<div style={{ width: '130px' }}>
          <img
            src={IMAGES.OYO_footer_logo}
            alt="OYO"
            width="89.5px"
            height="31px"
          />
        </div>}
        <div>
          {/*<span>{props.globalData.universal_translations.footer_header}</span>*/}
          <span
            style={{
              position: 'relative',
              height: '32px',
              left: '-10px',
              opacity: '0.3',
              fontSize: '24px',
              fontWeight: '500',
              fontStretch: 'normal',
              fontStyle: 'normal',
              lineHeight: '1.33',
              letterSpacing: 'normal',
              color: '#ffffff',
              padding: '5px'
            }}
          >
            {gc('footer_header')}

            {/*World's fastest growing hotel chain.*/}
          </span>
        </div>
      </div>
      <div style={{ ...footerHeadBottom }}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.globalData.universal_translations.our_story_link}
          onClick={() => {
            Event('Footer', 'Clicked on Our Story', '', '');
          }}
        >
          <div style={{ marginRight: '15px' }}>{guc('our_story')}</div>
        </a>
        <span>|</span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.globalData.universal_translations.official_oyo_blog_link}
          onClick={() => {
            Event('Footer', 'Clicked on OYO Official Blog', '', '');
          }}
        >
          <div style={{ marginRight: '15px', marginLeft: '15px' }}>
            {guc('official_oyo_blog')}
          </div>
        </a>
        {/*<span>|</span>*/}
        {/*<a*/}
        {/*  target="_blank"*/}
        {/*  rel="noopener noreferrer"*/}
        {/*  href={guc('press_kit_link')}*/}
        {/*  onClick={() => {*/}
        {/*    Event('Footer', 'Clicked on Press Kit', '', '');*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <div style={{ marginRight: '15px', marginLeft: '15px' }}>*/}
        {/*    {guc('press_kit')}*/}
        {/*  </div>*/}
        {/*</a>*/}
        <span>|</span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.globalData.universal_translations.refer_and_earn_link}
          onClick={() => {
            Event('Footer', 'Clicked on Refer and Earn', '', '');
          }}
        >
          <div style={{ marginRight: '15px', marginLeft: '15px' }}>
            {guc('refer_and_earn')}
          </div>
        </a>
        <span>|</span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.globalData.universal_translations.tnc_link}
          onClick={() => {
            Event('Footer', 'Clicked on Terms & Conditions', '', '');
          }}
        >
          <div style={{ marginRight: '15px', marginLeft: '15px' }}>
            {guc('terms_and_conditions')}
          </div>
        </a>
        <span>|</span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.globalData.universal_translations.privacy_policy_link}
          onClick={() => {
            Event('Footer', 'Clicked on Privacy Policy', '', '');
          }}
        >
          <div style={{ marginLeft: '15px' }}>{guc('privacy_policy')}</div>
        </a>
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterHead);
